import { HomeScreenSection } from '@strata/react-page-templates';
import { useNavigate } from 'react-router';

import { type AppRoutes } from 'services/routes';

interface StrataSuiteHomeSectionProps {
    title: string;
    sectionHomeRoute: (typeof AppRoutes)[keyof typeof AppRoutes];
    image: string;
    description: string;
}

export const StrataSuiteHomeSection = ({
    title,
    sectionHomeRoute,
    image,
    description,
}: StrataSuiteHomeSectionProps) => {
    const navigate = useNavigate();
    return (
        <div
            role="button"
            tabIndex={0}
            aria-label={description}
            onClick={() => navigate(sectionHomeRoute)}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    navigate(sectionHomeRoute);
                }
            }}
        >
            <HomeScreenSection
                sectionTitle={title}
                sectionContent={
                    <div className="sds_suite-home__section__section">
                        <img
                            className="padding__top--large padding__bottom--large"
                            src={image}
                            alt="Section Graphic"
                            loading="lazy"
                            style={{ margin: 'auto', display: 'block' }}
                        />
                        <div className="sds_suite-home__section__description">{description}</div>
                    </div>
                }
            />
        </div>
    );
};
